"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["Provider"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.regexp.to-string.js";
import { c as _c } from "react/compiler-runtime";
import { isAuthenticated } from '@autoguru/auth';
import { useDistributedState } from '@autoguru/distributed-state';
import { useViewerAccount } from '@autoguru/viewer-account';
import { createContext, useContext } from 'react';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const initialState = {
  globalSupplierSlug: null
};
const reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_STATE':
      return action.payload;
    default:
      return state;
  }
};
const CHANNEL_NAME = 'gSup';
export const globalSupplierContext = /*#__PURE__*/createContext(null);
const GlobalSupplierProviderComponent = ({
  children,
  viewerId
}) => {
  const _useDistributedState = useDistributedState({
      initialState,
      reducer,
      channelName: CHANNEL_NAME,
      userId: viewerId || useViewerAccount().dbId.toString(),
      storageType: 'URL'
    }),
    {
      Provider
    } = _useDistributedState,
    rest = _objectWithoutProperties(_useDistributedState, _excluded);
  return /*#__PURE__*/_jsx(globalSupplierContext.Provider, {
    value: _objectSpread({
      viewerId
    }, rest),
    children: /*#__PURE__*/_jsx(Provider, {
      children: children
    })
  });
};
export const useGlobalSupplier = () => {
  const {
    stateContext
  } = useContext(globalSupplierContext) || {
    stateContext: void 0,
    viewerId: void 0,
    cleanup: void 0,
    dispatch: void 0,
    dispatchAction: void 0
  };
  return stateContext ? useContext(stateContext) : {};
};
export const GlobalSupplierProvider = t0 => {
  const $ = _c(3);
  const {
    children,
    viewerId
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== viewerId) {
    t1 = isAuthenticated ? /*#__PURE__*/_jsx(GlobalSupplierProviderComponent, {
      viewerId: viewerId,
      children: children
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
    $[0] = children;
    $[1] = viewerId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default GlobalSupplierProvider;